<p class="title">Messages</p>
<article class="message">
  <div class="message-body">
    {#if $appState.company?.message}
      {@html $appState.company?.message}
    {:else}
      <p class="block">No messages at the moment.</p>
    {/if}
  </div>
</article>

<script lang="ts">
  import { appState } from '../../../../lib/appState';
</script>